import script from "./WelcomePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomePanel.vue?vue&type=script&setup=true&lang=js"

import "./WelcomePanel.vue?vue&type=style&index=0&id=3a653912&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a653912"]])

export default __exports__